import { MaskitoOptions } from '@maskito/core';

export const fourDigitInputMask: MaskitoOptions = {
  mask: /^\d{0,4}$/,
};
